import { Page } from 'layouts/Page';
import { FC } from 'react';
import { SupersetDashboard } from 'components/SupersetDashboard';

export const DashboardPage: FC = () => {
	return (
		<Page title="Dashboards – EAS Control Center">
			<SupersetDashboard />
		</Page>
	);
};
